<template>
  <div class="p-4 bg-white rounded shadow">
    <!-- Breadcrumb -->
    <div class="text-sm text-gray-600 mb-4">
      <span v-for="(folder, index) in breadcrumb" :key="folder.id" class="cursor-pointer hover:underline"
        @click="navigateToBreadcrumb(index)">
        {{ folder.name }} <span v-if="index < breadcrumb.length - 1">/</span>
      </span>
    </div>

    <!-- Tabla -->

    <scale-loader v-if="isLoading" />

    <table v-else class="w-full table-auto">
      <thead>
      <tr class="text-left text-gray-500 border-b text-sm">
        <th class="py-2 w-1/2">{{ $t('name') }}</th>
        <th class="py-2">{{ $t('modified') }}</th>
        <th class="py-2">{{ $t('modified_by') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="item in currentItems"
        :key="item.id"
        @dblclick="openFolder(item)"
        @click="selectItem(item)"
        :class="[
        'border-b cursor-pointer text-sm',
        selectedItem && selectedItem.id === item.id ? 'bg-gray-100' : ''
        ]"
      >
        <td class="py-2 w-1/2 break-words">
        <span v-if="item.folder">📁</span>
        <span v-else>🖼️</span>
        {{ item.name }}
        </td>
        <td class="py-2"><span class="text-gray-600">{{ moment(item.lastModifiedDateTime).fromNow() }}</span></td>
        <td class="py-2"><span class="bg-gray-200 px-2 py-1 rounded-full text-gray-600">{{ item.lastModifiedBy
          }}</span></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import axios from "axios";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import moment from 'moment';

export default {
  data() {
    return {
      currentItems: [],
      breadcrumb: [{ id: 'root', name: 'Documents' }],
      selectedItem: null,
      isLoading: false,
    }
  },
  components: {
    ScaleLoader
  },
  computed: {
    ...mapGetters({
      company: 'app/company',
      project: 'app/project'
    }),
  },
  methods: {
    async fetchData(folderId) {
      this.isLoading = true
      const {data} = await axios.get(`/api/v2/sharepoint-key/${this.company.id}/${this.project.id}/folder`, {
        params: { folderId }
      })
      this.currentItems = data.data
      this.isLoading = false
    },
    openFolder(item) {
      // si no es un carpeta, no hacemos nada
      if (!item.folder) return
      // preparamos el path y la info de la carpeta para agregarlo a la breadcrumb
      let bCount = this.breadcrumb.length
      let path = bCount == 1 ? item.name : this.breadcrumb[bCount - 1].path + '/' + item.name
      this.breadcrumb.push({ id: item.id, name: item.name, path })
      // volvemos a cargar la data de la carpeta abierta
      this.fetchData(item.id)
      this.selectedItem = null
    },
    navigateToBreadcrumb(index) {
      const target = this.breadcrumb[index]
      this.breadcrumb = this.breadcrumb.slice(0, index + 1)
      this.fetchData(target.id)
      this.selectedItem = null
      this.$emit('selected-folder', target.id == 'root' ? null : target)
    },
    selectItem(item) {
      // de momento solo se puede seleccionar carpetas
      if (!item.folder) return
      this.selectedItem = item
      // volvemos a generar el path para agregar la info de la carpeta seleccionada
      let bCount = this.breadcrumb.length
      let path = bCount == 1 ? item.name : this.breadcrumb[bCount - 1].path + '/' + item.name
      // enviamos la info de la carpeta seleccionada al padre
      this.$emit('selected-folder', {...item, path})
    },
  },
  mounted() {
    this.fetchData('root')
  }
}
</script>
